import {StoryblokComponent} from "@storyblok/react";

let Page = ({blok}) => {
    return <>
        {blok.Rows.map((row) => <StoryblokComponent blok={row}/>)}
    </>
}

export default Page